import type React from "react";

import { Trash2 } from "lucide-react";

import { ConfirmationModal } from "@/components/confirmation-modal/ConfirmationModal";

interface DeleteItemModalProps {
  readonly bodyText?: string;
  readonly isConfirmLoading?: boolean;
  readonly isOpen: boolean;
  readonly itemLabel: string;
  readonly onConfirm: () => void;
  readonly onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
}

export function DeleteItemModal({
  bodyText,
  isConfirmLoading,
  isOpen,
  itemLabel,
  onConfirm,
  onOpenChange,
}: DeleteItemModalProps) {
  return (
    <ConfirmationModal
      className="max-sm:h-full max-sm:rounded-none sm:w-[400px]"
      confirmButtonText="Delete"
      icon={<Trash2 className="text-fg-error-secondary" size={20} />}
      isConfirmLoading={isConfirmLoading}
      isOpen={isOpen}
      modalOverlayClassName="max-sm:pt-0"
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      text={
        bodyText ?? `This ${itemLabel} will be removed from the brand overview.`
      }
      title={`Delete ${itemLabel}`}
    />
  );
}
